exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._27w6kgshubruQOZIqSfVsi{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:20px 0}.NzOvnZMZwGQ-N-WijuiPX{margin:10px}", ""]);

// exports
exports.locals = {
	"grid": "_27w6kgshubruQOZIqSfVsi",
	"item": "NzOvnZMZwGQ-N-WijuiPX"
};